import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";

const useDialogStyles = makeStyles({
  closeButtonContainer: {
    width: "100%"
  },

  popoverStyling: {
    width: "175px"
  }
});

export default function ExplainMoreDialog(props) {
  const { step, children } = props;
  const classes = useDialogStyles();

  const information = {
    0: {
      title: "Wähle einen Ausgangstext",
      explanation:
        "In diesem Szenario ist der Ausgangstext ein beliebiges neues Dokument; aus diesem sollen mit Hilfe automatisierter Analysetechniken relevante Kernaussagen extrahiert werden."
    },
    1: {
      title: "Wähle einen Vergleichstext",
      explanation:
        "Nun wird ein zu vergleichender Text gewählt, um Schlüsselwörter und Verwandtschaften der beiden gewählten Texte näher zu betrachten."
    },
    2: {
      title: "Wähle Schlüsselwörter und Taxa",
      explanation:
        "Die extrahierten Schlüsselwörter sind schließlich Kandidaten für die Erweiterung der bestehenden Unternehmenstaxonomie. Anhand der farblichen Markierung erkennt man, in welche Gruppe taXonomy die Schlüsselwörter einsortiert hat."
    },
    3: {
      title: "Interagiere mit dem 3D Modell",
      explanation:
        "Hier sieht man, wie nah die gewählten Schlüsselwörter und Taxa beieinander liegen und wie sie verknüpft werden könnten. Durch Klicken, Hovern und Zoomen mit der Maus wird mit dem Modell interagiert."
    }
  };

  return (
    <Tooltip
      id={information[step].title}
      classes={{ tooltip: classes.popoverStyling }}
      title={information[step].explanation}
      placement="right-start"
    >
      {children}
    </Tooltip>
  );
}
